import { render, staticRenderFns } from "./ListaActividades.vue?vue&type=template&id=8c44720e&scoped=true&"
import script from "./ListaActividades.vue?vue&type=script&lang=js&"
export * from "./ListaActividades.vue?vue&type=script&lang=js&"
import style0 from "./ListaActividades.vue?vue&type=style&index=0&id=8c44720e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c44720e",
  null
  
)

export default component.exports